import React, { useState, useEffect, useContext } from "react";
import { useForm, useStep } from "react-hooks-helper";
import ShowEmail from "pages/ShowEmail";
import ChangeEmail from "pages/ChangeEmail";
import TokenValidate from "pages/TokenValidate";
import Success from "pages/Success";
import { Text } from "mondrian-react";
import { getEmail } from "core/api/changeEmail/changeEmailApi";
import { store } from "../../store";
import Input from "components/Input";
import Loading from "components/Loading";
import ButtonGroup from "components/ButtonGroup";
import { useHistory } from "react-router-dom";
import Button from "components/Button";
import Modal from "components/Modal";
const steps = [
  { id: "showemail" },
  { id: "changeemail" },
  { id: "tokenvalidate" },
  { id: "success" },
];

const defaultData = {};

const AlterarEmail = ({ images }) => {
  const history = useHistory();
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const [tabCount, setTabCount] = useState(0);
  const [firstTab, setFirstTab] = useState(false);
  const [formData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const [isLoading, setIsLoading] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const props = {
    formData,
    setForm,
    navigation,
    setIsLoading,
    isLoading,
    setModalContent,
  };
  const { accesstoken } = state;

  useEffect(() => {
    if (!state.user?.updatedEmails) {
      getEmailService(accesstoken);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accesstoken,state.user]);

  function onFocusHandle(e) {
    if (tabCount >= 1) {
      console.clear();
      setFirstTab(true);
    }
    setTabCount(tabCount + 1);
    props.firstTab = firstTab;
  }

  const onKeyDown = (e) => {
    if (e.key === "Tab" && !firstTab) {
      e.preventDefault();
      const el = document.getElementById("mdn-Header");
      if (el) document.getElementById("mdn-Header").focus();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  async function getEmailService(accesstoken) {
    setIsLoading(true);
    let result = await getEmail(accesstoken);

    let { error = null, data = {} } = result;
    let { loginEmails } = data;

    if (error != null) {
      const { message, originalMessage = message } = error.warning;
      
      setModalContent(error);
      setIsLoading(false);

      return null;
    }

    if (loginEmails) {
      dispatch({
        type: "SET_USER_DATA",
        payload: {
          email: loginEmails[loginEmails.length - 1],
          updatedEmails: true,
        },
      });
    }

    setIsLoading(false);
  }

 
  switch (id) {
    case "showemail":
      return (
        <>
          <Loading isLoading={isLoading} /> <ShowEmail {...props} />
        </>
      );
    case "changeemail":
      return (
        <>
          <Loading isLoading={isLoading} /> <ChangeEmail {...props} />
        </>
      );
    case "tokenvalidate":
      return (
        <>
          <Loading isLoading={isLoading} /> <TokenValidate {...props} />
        </>
      );
    case "success":
      return (
        <Success
          {...props}
          firstTab={firstTab}
          title="Email alterado com sucesso"
        >
          <Text>
            Agora você pode realizar o acesso com o e-mail que acabou de criar.
            Lembrando que a sua senha permanece a mesma para todos os seus
            produtos.
          </Text>
          <ButtonGroup>
            <Button
              tabIndex="20"
              secondary
              onFocus={onFocusHandle}
              onKeyDown={onKeyDown}
              onClick={() => history.push("/meuperfil")}
            >
              Retornar ao Meu Perfil
            </Button>
          </ButtonGroup>
        </Success>
      );
    default:
      return null;
  }
};

export default AlterarEmail;
